
<template>
  <div v-if="loading" class="loader center s">
    <loading-circle />
  </div>
  <div class="reports" v-else>
    <div class="module-header v-center px-3">
      <img
        class="mr-3 pointer"
        src="~@/assets/images/icons/arrow-back.svg"
        width="30px"
        alt=""
        @click="goBack"
      />
      <h1 class="module-name">Reports</h1>
    </div>
    <div class="reports-filters">
      <div>Filters</div>
      <div class="space-between">
        <div class="flex gap-1">
          <multiselect-dropdown
            label="Projects"
            :options="projects"
            @selected="setProjectFilters"
            :initiallySelected="appliedFilters.projectIds"
          />
          <multiselect-dropdown
          v-if="adminProjetcts.length > 0"
            label="Users"
            :options="associatedUsers"
            @selected="setUserFilters"
            :initially-selected="appliedFilters.userIds"
          />
          <div class="dropdown"  @mouseleave="emitSelected">
            <div v-if="appliedFilters.tags.length" class="selectedCount">
        {{ appliedFilters.tags.length }}
      </div>
    <button class="dropdown-toggle"  @click="showDropdown = !showDropdown">
      Tags
    </button>
    <div class="dropdown-content" v-show="showDropdown">
      <input
        type="text"
        v-model="search"
        placeholder="Search..."
      />
      <filter-multi-select-drop-down
      :options="tags"
        :initially-selected="appliedFilters.tags"
        :search="search"
        @selected-partial="collectChildSelections"
        @selected="handleParentSelected"/>
      </div>
    </div>
          <!-- <multiselect-dropdown
            label="Tags"
            :options="tags"
            @selected="setTagFilters"
            :initially-selected="appliedFilters.tags"
          /> -->
          <div class="date-range">
            <span>From:</span>
            <input
              type="date"
              class="ml-3"
              v-model="filters.from"
              @change="[applyButton = false,filters.upto=filters.from]"
            />
            <span class="ml-3">Upto:</span>
            <input
              type="date"
              class="ml-3"
              v-model="filters.upto"
              :min="filters.from"
              @change="applyButton = false"
            />
          </div>
          <button class="btn" :disabled="applyButton" @click="applyFilters">
            Apply
          </button>
          <button class="btn" @click="clearFilter">
            Clear
          </button>
        </div>

        <div>
        </div>
      </div>
    </div>
    <div class="flex lineCharts">
      <apexchart
        class="lineCharts-single"
        type="line"
        height="350"
        :options="chartOptions"
        :series="projectSeries"
      />
      <apexchart
        ref="userTimeSpentChart"
        class="lineCharts-single"
        type="line"
        height="350"
        :options="userChartOptions"
        :series="userSeries"
      />
    </div>
    <div id="chart" class="h-center mt-9">
      <apexchart
        type="pie"
        width="600"
        :options="piechartOptions"
        :series="pieChartSeries"
      ></apexchart>
      <apexchart
      class="lineCharts-single"
        type="line"
        height="350"
        :options="reworkChartOptions"
        :series="reworkSeries"
      >
      </apexchart>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unmodified-loop-condition */
import MultiselectDropdown from '../../components/common/multiselectDropdown.vue'
import { mapGetters } from 'vuex'
import { GetReportsData, GetAllTaskTags, getProjectUserExceptViewer, GetUserListByPojIds, getTimesheetByUserIdAndEntryDate } from '@/api'
import loadingCircle from '../../components/common/loadingCircle.vue'
import { alert } from '../../plugins/notification'
import filterMultiSelectDropDown from '@/components/common/filterMultiSelectDropDown.vue'
export default {
  name: 'timeSheetReports',
  components: {
    MultiselectDropdown,
    loadingCircle,
    filterMultiSelectDropDown
  },
  methods: {
    emitSelected () {
      if (this.parentSelectedIds.length || this.allSelectedIds.length) {
        const merged = new Set([...this.parentSelectedIds, ...this.allSelectedIds])
        const finalIds = Array.from(merged)
        this.setTagFilters(finalIds)
      }
      this.showDropdown = false
    },
    applyFilters () {
      this.loading = true
      this.getChartData(this.filters)
    },
    clearFilter () {
      this.appliedFilters = {
        projectIds: [],
        userIds: [],
        tags: []
      }
      this.filters = {
        projectIds: [],
        userIds: [],
        tags: []
      }
      this.setInitialDates()
      this.getChartData(this.filters)
    },
    goBack () {
      this.$router.go(-1)
    },
    setProjectFilters (projectIds) {
      this.filters.projectIds = projectIds
      this.applyButton = false
      this.associatedUsers = []
      const adminProjectIds = []
      projectIds.forEach((id) => {
        this.adminProjetcts.forEach((project) => {
          if (project.id === id) {
            adminProjectIds.push(id)
          }
        })
      })
      this.associatedUsers = []
      adminProjectIds.length && this.getUsersList(adminProjectIds)
    },
    setUserFilters (userIds) {
      this.filters.userIds = userIds
      this.applyButton = false
    },
    handleParentSelected (selectedIds) {
      this.parentSelectedIds = selectedIds
    },
    collectChildSelections (partialIds) {
      const merged = new Set([...this.allSelectedIds, ...partialIds])
      this.allSelectedIds = Array.from(merged)
    },
    setTagFilters (tags) {
      this.filters.tags = tags
      this.applyButton = false
    },
    getOneMonthBeforeDate (currentDate) {
      const oneMonthBefore = new Date(currentDate)
      oneMonthBefore.setMonth(oneMonthBefore.getMonth() - 1)
      return this.formatDate(oneMonthBefore)
    },
    generateDatesInRange (startDate, endDate) {
      const dates = {}
      const options = {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
      }
      const currentDate = new Date(startDate)
      let i = 0
      while (currentDate <= endDate) {
        const date = currentDate.toLocaleString('en-GB', options)
        this.userChartDateIsoByIndex.push(this.formatDate(currentDate))
        dates[new Date(currentDate).setUTCHours(0, 0, 0, 0)] = i
        this.userChartOptions.xaxis.categories.push(date)
        this.chartOptions.xaxis.categories.push(date)
        this.reworkChartOptions.xaxis.categories.push(date)
        currentDate.setDate(currentDate.getDate() + 1)
        i++
      }
      return dates
    },
    formatDate (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    escapeHtml (value = '') {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },
    formatHours (duration = 0) {
      const numericDuration = Number(duration || 0)
      if (Number.isNaN(numericDuration)) return '0.00'
      return numericDuration.toFixed(2)
    },
    getTooltipTotalHours (cacheValue, fallbackHours) {
      if (!cacheValue || !Array.isArray(cacheValue.items) || !cacheValue.items.length) {
        return this.formatHours(fallbackHours)
      }
      const total = cacheValue.items.reduce((sum, item) => {
        return sum + Number(item.duration || 0)
      }, 0)
      return this.formatHours(total)
    },
    toIsoDateString (displayDate) {
      if (!displayDate) return ''
      const parts = displayDate.split('/')
      if (parts.length !== 3) return ''
      const day = parts[0]
      const month = parts[1]
      const shortYear = Number(parts[2])
      if (!day || !month || Number.isNaN(shortYear)) return ''
      const year = shortYear >= 70 ? 1900 + shortYear : 2000 + shortYear
      return `${year}-${month}-${day}`
    },
    getUserChartDisplayDate (w, dataPointIndex) {
      return (
        w?.globals?.categoryLabels?.[dataPointIndex] ||
        w?.config?.xaxis?.categories?.[dataPointIndex] ||
        this.userChartDateIsoByIndex[dataPointIndex] ||
        ''
      )
    },
    async handleUserTimePointHover (config) {
      const seriesIndex = config?.seriesIndex
      const dataPointIndex = config?.dataPointIndex
      if (seriesIndex < 0 || dataPointIndex < 0) return
      const selectedSeries = this.userSeries[seriesIndex]
      const userId = selectedSeries?.userId
      if (!userId) return
      const hoveredDisplayDate = this.getUserChartDisplayDate(config?.w, dataPointIndex)
      const hoveredDate = this.userChartDateIsoByIndex[dataPointIndex] || this.toIsoDateString(hoveredDisplayDate) || hoveredDisplayDate
      if (!hoveredDate) return
      const cacheKey = `${userId}_${hoveredDate}`
      if (this.userTimesheetTooltipCache[cacheKey]?.loading || this.userTimesheetTooltipCache[cacheKey]?.fetched) {
        return
      }
      this.$set(this.userTimesheetTooltipCache, cacheKey, {
        loading: true,
        fetched: false,
        items: [],
        error: ''
      })
      try {
        const response = await getTimesheetByUserIdAndEntryDate(userId, hoveredDate)
        const entries = response?.user_timesheet || []
        const tasksMap = {}
        entries.forEach((item) => {
          const duration = Number(item.duration || 0)
          if (duration <= 0) return
          const projectName = item?.core_project?.name || 'Unknown project'
          const taskName = item?.core_task?.name
            ? `${item.core_task.name} (${projectName})`
            : `N/A (${projectName})`
          if (tasksMap[taskName]) {
            tasksMap[taskName] += duration
          } else {
            tasksMap[taskName] = duration
          }
        })
        const taskBreakdown = Object.entries(tasksMap).map(([taskName, duration]) => ({
          taskName,
          duration
        }))
        this.$set(this.userTimesheetTooltipCache, cacheKey, {
          loading: false,
          fetched: true,
          items: taskBreakdown,
          error: ''
        })
      } catch (error) {
        this.$set(this.userTimesheetTooltipCache, cacheKey, {
          loading: false,
          fetched: false,
          items: [],
          error: 'Failed to load task details'
        })
      }
    },
    buildUserTimeTooltip ({ series, seriesIndex, dataPointIndex, w }) {
      const selectedSeries = w?.config?.series?.[seriesIndex] || this.userSeries[seriesIndex] || {}
      const userName = selectedSeries?.name || 'User'
      const userId = selectedSeries?.userId
      const displayDate = this.getUserChartDisplayDate(w, dataPointIndex)
      const hoveredDate = this.userChartDateIsoByIndex[dataPointIndex] || this.toIsoDateString(displayDate) || displayDate
      const hoveredHours = series?.[seriesIndex]?.[dataPointIndex]
      const cacheKey = `${userId}_${hoveredDate}`
      const cacheValue = this.userTimesheetTooltipCache[cacheKey]
      const totalHours = this.getTooltipTotalHours(cacheValue, hoveredHours)
      const titleHtml = `
        <div style="font-weight:600;margin-bottom:6px;">${this.escapeHtml(userName)}</div>
        <div style="margin-bottom:4px;"><b>Date:</b> ${this.escapeHtml(displayDate || hoveredDate)}</div>
        <div style="margin-bottom:8px;"><b>Total:</b> ${totalHours} hrs</div>
      `
      if (!userId || !hoveredDate) {
        return `<div class="apexcharts-tooltip-box" style="padding:10px;max-width:320px;">${titleHtml}<div>User details unavailable</div></div>`
      }
      if (!cacheValue || cacheValue.loading) {
        if (!cacheValue) {
          this.handleUserTimePointHover({ seriesIndex, dataPointIndex })
        }
        return `<div class="apexcharts-tooltip-box" style="padding:10px;max-width:320px;">${titleHtml}<div>Loading task details...</div></div>`
      }
      if (cacheValue.error) {
        return `<div class="apexcharts-tooltip-box" style="padding:10px;max-width:320px;">${titleHtml}<div>${this.escapeHtml(cacheValue.error)}</div></div>`
      }
      if (!cacheValue.items.length) {
        return `<div class="apexcharts-tooltip-box" style="padding:10px;max-width:320px;">${titleHtml}<div>No tasks logged</div></div>`
      }
      const listHtml = cacheValue.items.map((item) => (
        `<div style="display:flex;justify-content:space-between;gap:12px;margin-bottom:4px;">
          <span>${this.escapeHtml(item.taskName)}</span>
          <span>${this.formatHours(item.duration)} hrs</span>
        </div>`
      )).join('')
      return `<div class="apexcharts-tooltip-box" style="padding:10px;max-width:320px;">${titleHtml}${listHtml}</div>`
    },
    attachUserChartHoverHandler () {
      this.userChartOptions = {
        ...this.userChartOptions,
        chart: {
          ...this.userChartOptions.chart,
          events: {
            mouseMove: (event, chartContext, config) => {
              this.handleUserTimePointHover(config)
            }
          }
        },
        tooltip: {
          ...this.userChartOptions.tooltip,
          custom: ({ series, seriesIndex, dataPointIndex, w }) => this.buildUserTimeTooltip({ series, seriesIndex, dataPointIndex, w })
        }
      }
    },
    setInitialDates () {
      const currentDate = new Date()
      const currentFormattedDate = this.formatDate(currentDate)
      const oneMonthBeforeFormattedDate =
        this.getOneMonthBeforeDate(currentDate)
      this.filters.from = oneMonthBeforeFormattedDate
      this.filters.upto = currentFormattedDate
    },
    getChartData (filters) {
      this.loading = true
      GetReportsData(filters)
        .then((res) => {
          const projectData = {}
          const userData = {}
          const projectsReworkData = {}
          const hoursPerUser = {}
          const userMeta = {}
          this.chartOptions.xaxis.categories = []
          this.userChartOptions.xaxis.categories = []
          this.reworkChartOptions.xaxis.categories = []
          this.userChartDateIsoByIndex = []
          this.userTimesheetTooltipCache = {}
          this.userSeries = []
          this.projectSeries = []
          this.pieChartSeries = []
          this.reworkSeries = []
          this.piechartOptions.labels = []
          const dates = this.generateDatesInRange(new Date(filters.from), new Date(filters.upto))
          const numberOfDates = Object.keys(dates).length
          // Changing structure of the data from the backend to a structure to use in chart.
          res.message.projects.forEach((item) => {
            const dateIndex = dates[new Date(item.entry_date).setUTCHours(0, 0, 0, 0)]
            const itemHours = Number(item.hours || 0)
            if (projectData[item.project_name]) {
              projectData[item.project_name][dateIndex] =
                projectData[item.project_name][dateIndex] + itemHours
            } else {
              projectData[item.project_name] = new Array(numberOfDates).fill(0)
              projectData[item.project_name][dateIndex] =
                projectData[item.project_name][dateIndex] + itemHours
            }
          })
          res.message.projectsRework.forEach((item) => {
            const dateIndex = dates[new Date(item.entry_date).setUTCHours(0, 0, 0, 0)]
            const itemHours = Number(item.hours || 0)
            if (projectsReworkData[item.project_name]) {
              projectsReworkData[item.project_name][dateIndex] =
                projectsReworkData[item.project_name][dateIndex] + itemHours
            } else {
              projectsReworkData[item.project_name] = new Array(numberOfDates).fill(0)
              projectsReworkData[item.project_name][dateIndex] =
                projectsReworkData[item.project_name][dateIndex] + itemHours
            }
          })
          res.message.users.forEach((item) => {
            const userKey = item.user_id || item.user_name
            const dateIndex = dates[new Date(item.entry_date).setUTCHours(0, 0, 0, 0)]
            const itemHours = Number(item.hours || 0)
            if (userData[userKey]) {
              userData[userKey][dateIndex] = userData[userKey][dateIndex] + itemHours
            } else {
              userData[userKey] = new Array(numberOfDates).fill(0)
              userData[userKey][dateIndex] = userData[userKey][dateIndex] + itemHours
            }
            userMeta[userKey] = {
              userId: item.user_id || null,
              userName: item.user_name
            }
            if (hoursPerUser[item.user_name]) {
              hoursPerUser[item.user_name] =
                hoursPerUser[item.user_name] + item.hours
            } else {
              hoursPerUser[item.user_name] = item.hours
            }
          })
          for (const [key, value] of Object.entries(projectData)) {
            this.projectSeries.push({
              name: key,
              data: value
            })
          }
          for (const [key, value] of Object.entries(projectsReworkData)) {
            this.reworkSeries.push({
              name: key,
              data: value
            })
          }
          for (const [key, value] of Object.entries(userData)) {
            this.userSeries.push({
              name: userMeta[key]?.userName || key,
              data: value,
              userId: userMeta[key]?.userId || null
            })
          }
          for (const [key, value] of Object.entries(hoursPerUser)) {
            this.pieChartSeries.push(value)
            this.piechartOptions.labels.push(key)
          }
          if (filters.projectIds) { this.appliedFilters.projectIds = filters.projectIds }
          if (filters.userIds) this.appliedFilters.userIds = filters.userIds
          if (filters.tags) this.appliedFilters.tags = filters.tags
          this.applyButton = true
        })
        .catch((err) => {
          console.log(err)
          alert('Failed to fetch')
        })
        .finally(() => {
          this.loading = false
        }).catch((err) => {
          console.log(err)
          alert('Failed to fetch')
        })
    },
    getProjectsWithNotViewer () {
      // this function is to avoid projects those have given user is not associated  as viewer
      getProjectUserExceptViewer(this.user.userId).then((res) => {
        this.projects = res?.project_user_association.map((obj) => {
          return {
            value: obj?.associated_project?.id,
            label: obj?.associated_project?.name
          }
        })
      }
      )
    },
    getUsersList (projectIds) {
      this.associatedUsers = [] // TO reset users list based on selected project
      const userIdForTemp = []
      GetUserListByPojIds(projectIds).then((res) => {
        this.associatedUsers = res.project_user_association.filter((user) => {
          // to remove the duplication need to check whether the user Data is already added or not
          // since there is no project id while fetching project_associated users initilly need to this one
          if (!userIdForTemp.includes(user.associated_user.id)) {
            userIdForTemp.push(user.associated_user.id)
            return true
          }
        }).map((filteredUser) => {
          return {
            label:
            filteredUser.associated_user.first_name +
              ' ' +
              filteredUser.associated_user.last_name,
            value: filteredUser.associated_user.id
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  data () {
    return {
      applyButton: true,
      allSelectedIds: [],
      parentSelectedIds: [],
      filters: {
        from: '',
        upto: '',
        projectIds: [],
        userIds: [],
        tags: []
      },
      appliedFilters: {
        projectIds: [],
        userIds: [],
        tags: []
      },
      associatedUsers: [],
      userChartDateIsoByIndex: [],
      userTimesheetTooltipCache: {},
      loading: true,
      projects: [],
      tags: [],
      projectSeries: [],
      userSeries: [],
      reworkSeries: [],
      pieChartSeries: [],
      showDropdown: false,
      search: '',
      piechartOptions: {
        chart: {
          width: 380,
          type: 'pie'
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ]
      },
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: 'Time spent for each project',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return String(Math.round(Number(value || 0)))
            }
          }
        },
        xaxis: {
          categories: []
        }
      },
      userChartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        tooltip: {
          shared: false,
          intersect: true,
          followCursor: true,
          offsetY: 4
        },
        markers: {
          size: 4,
          hover: {
            size: 6
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: 'Time spend by each users',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return String(Math.round(Number(value || 0)))
            }
          }
        },
        xaxis: {
          categories: []
        }
      },
      reworkChartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: 'Time spend by each reworks',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return String(Math.round(Number(value || 0)))
            }
          }
        },
        xaxis: {
          categories: []
        }
      }
    }
  },
  computed: {
    ...mapGetters(['user', 'getUserById', 'adminProjetcts']),
    ...mapGetters(['tenantUsersList', 'tenantProjectList'])
  },
  mounted () {
    GetAllTaskTags().then(res => {
      res.tag.forEach((item) => {
        if (item.parent_id === null) {
          this.tags.push({
            value: item?.id,
            label: item?.name,
            isExpanded: false
          })
        }
      })
    })
    this.getProjectsWithNotViewer()
    this.attachUserChartHoverHandler()
    this.setInitialDates()
    this.getChartData(this.filters)
    // this.tenantUsersList.forEach((item) => {
    //   if (item.status === 1) {
    //     this.users.push({
    //       value: item?.associated_user?.id,
    //       label:
    //       item?.associated_user?.first_name +
    //       ' ' +
    //       item?.associated_user?.last_name
    //     })
    //   }
    // })
  }
}
</script>

  <style lang="scss">
.reports {
  position: relative;
  &-filters {
    margin: 4px;
    margin-top: 1rem;
    padding: 10px;
    border: var(--border);
    position: sticky;
    top: 0px;
    z-index: 3;
    background-color: white;
  }
}
.selectedCount {
    border-radius: 50%;
    position: absolute;
    top: -4px;
    padding: 3px 10px;
    background: var(--brand-color);
    right: -9px;
  }
.lineCharts {
  margin-top: 4rem;
  &-single {
    width: 50%;
  }
}

.date-range {
  input {
    height: 100%;
    border: .7px solid var(--brand-color);
    border-radius: 5px;
    padding-inline: 4px;
    background: var(--brand-light-color);
  }
}
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-toggle {
  background-color: var(--brand-light-color);
  border: 1px solid var(--brand-color);
  padding: 8px 12px;
  cursor: pointer;
  height: 40px;
  width: 200px;
  border-radius: 0.3em;
}

.dropdown-content {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0.1em 0.1em 0.1em rgba(0, 0, 0, 0.25);
  padding: 8px;
  z-index: 2;
  width: 200px;
  max-height: 365px;
  overflow: scroll;
  & input{
    padding: 5px;
    border-radius: 4px;
    border-color: rgb(30, 27, 27,.3);
    border-style: solid;
  }
  & input:focus{
    border-color: rgb(30, 27, 27,.7);
    border-style: solid;
  }
}

.dropdown-content label {
  margin-bottom: 5px;
}
.loader {
  padding: 18rem;
}
</style>
